import { render } from "./UpdateSong.vue?vue&type=template&id=61743ca0&scoped=true"
import script from "./UpdateSong.vue?vue&type=script&lang=js"
export * from "./UpdateSong.vue?vue&type=script&lang=js"

import "./UpdateSong.vue?vue&type=style&index=0&id=61743ca0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61743ca0"

export default script